// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"OZ-z","subtitle":"PZ-z","wrapper":"QZ-z","leftArrow":"RZ-z","rightArrow":"SZ-z"};